module.exports = __webpack_public_path__ + "img/20200515_163044.677a1ac8.jpg";